export function fractionToPercentage(value: string | number | null): number | null {
  if (!value) return 0
  // whatever the input is, cast it to a number
  const number = Number(value?.toString())
  
  // Make a percentage of the fraction (number * 100) and set it to 2 decimal places
  return Number((number * 100).toFixed(2)) ?? 0
}
